export default __webpack_public_path__ + "static/media/bubbles_card.928d7e8f.svg";